import { createContext } from 'react'

// Сохраняем выбор чекбокса гражданство
export const CitizenshipContext = createContext(null)
